import { SVGProps } from "react"

const ChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="m6.258 9.517 5.796-5.526a.74.74 0 0 1 1.012 0l.676.644a.66.66 0 0 1 0 .965L9.15 10l4.593 4.4a.66.66 0 0 1-.001.964l-.676.645a.74.74 0 0 1-1.012 0l-5.796-5.526a.66.66 0 0 1 0-.966Z"
    />
    <path
      fill="#000"
      fillOpacity={0.2}
      d="m6.258 9.517 5.796-5.526a.74.74 0 0 1 1.012 0l.676.644a.66.66 0 0 1 0 .965L9.15 10l4.593 4.4a.66.66 0 0 1-.001.964l-.676.645a.74.74 0 0 1-1.012 0l-5.796-5.526a.66.66 0 0 1 0-.966Z"
    />
    <path
      fill="#000"
      fillOpacity={0.2}
      d="m6.258 9.517 5.796-5.526a.74.74 0 0 1 1.012 0l.676.644a.66.66 0 0 1 0 .965L9.15 10l4.593 4.4a.66.66 0 0 1-.001.964l-.676.645a.74.74 0 0 1-1.012 0l-5.796-5.526a.66.66 0 0 1 0-.966Z"
    />
  </svg>
)
export default ChevronRight
